import styled from 'styled-components'

export const Wrapper = styled.div`
  position: fixed;
  display: grid;
  justify-content: center;
  align-items: center;
  height: 100vh;
  left: 0;
  top: 0;
  width: 100vw;
  z-index: 999;
`
export const Background = styled.div`
  display: grid;
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: grey;
  opacity: 0.5;
`
